import React from 'react';
import PropTypes from 'prop-types';

import RatingV5 from './RatingV5';
import usePickleballRatingProps from '../../hooks/usePickleballRatingProps';
import { gameTypes } from '../../../utils/constants';

const PickleballRating = props => {
    const {
        profileData,
        isOwnProfile,
        onPickleballGetRatedClick,
        'data-testid': dataTestId,
    } = props;

    const {
        hasSinglesRating,
        hasDoublesRating,
        hasEstimatedRange,
    } = usePickleballRatingProps(profileData);

    const showGetRatedButton = !hasSinglesRating && !hasDoublesRating && !hasEstimatedRange && isOwnProfile;

    const getPickleballRating = (gameType) => {
        const ratingProps = {
            title: `UTR-P`,
            value: '',
            footer: '',
            isVerified: false,
            showRatingInfo: true,
            gameType,
        };

        if (gameType === gameTypes.SINGLES) {
            // show verified / unverified / historic rating (handled by backend)
            if (hasSinglesRating) {
                const rating = profileData.singlesPkbRatingDisplay;
                ratingProps.value = rating.pkbRating;
                ratingProps.footer = rating.historicRatingDate || rating.reliability;
                ratingProps.isVerified = rating.isVerified;
            // 4. show estimated rating if available
            } else if (hasEstimatedRange) {
                ratingProps.gameType = null;
                ratingProps.value = profileData.utrRange?.pkbRatingDisplay;
                ratingProps.footer = 'Estimated';
            // 5. show Get Rated
            } else if (showGetRatedButton) {
                ratingProps.title = 'UTR-Pickleball';
                ratingProps.gameType = null;
                ratingProps.showGetRatedButton = true;
                ratingProps.showRatingInfo = false;
            // 6. show Unrated
            } else {
                ratingProps.gameType = null;
            }
        } else if (hasDoublesRating) {
            // show verified / unverified / historic rating (handled by backend)
            const rating = profileData.doublesPkbRatingDisplay;
            ratingProps.value = rating.pkbRating;
            ratingProps.footer = rating.historicRatingDate || rating.reliability;
            ratingProps.isVerified = rating.isVerified;
        }
        return (
            <RatingV5
                title="UTR-P"
                titleColor="green"
                value={profileData.utrRange?.pkbRatingDisplay}
                onGetRatedClick={onPickleballGetRatedClick}
                ratingInfoType="pickleball"
                {...ratingProps}
                data-testid={dataTestId ? `${dataTestId}.${gameType || 'singles'}` : undefined}
            />
        );
    };
    return (
        <>
            {(hasSinglesRating || !hasDoublesRating) && getPickleballRating(gameTypes.SINGLES)}
            {hasDoublesRating && getPickleballRating(gameTypes.DOUBLES)}
        </>
    );
};

PickleballRating.defaultProps = {
    isOwnProfile: false,
};

PickleballRating.propTypes = {
    profileData: PropTypes.instanceOf(Object).isRequired,
    isOwnProfile: PropTypes.bool,
    onPickleballGetRatedClick: PropTypes.func.isRequired,
};

export default PickleballRating;
